import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/common.css";


//网络请求配置
//在main.js中引入axios
import axios from 'axios'
//引入 baseurl.js
import domain from './http/utils'
//引入 common.js
import common from './http/common'
//引入 common.js
import API_URL from './api/api'



const app = createApp(App).use(store).use(router)
//配置axios
//->1,模块一接口,url地址
axios.defaults.baseM1URL = domain.Base_M1_URL
//->2,模块二接口,url地址
axios.defaults.baseM2URL = domain.Base_M2_URL
//->3,模块三接口,url地址
axios.defaults.baseM3URL = domain.Base_M3_URL
//网络请求配置


app.config.globalProperties.$domain = domain;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$http = common;
app.config.globalProperties.$API_URL = API_URL;


app.mount('#app')